<template>
  <div
    class="group relative z-10 mr-2 cursor-pointer rounded bg-accent dark:bg-[#a49ce8]/25 p-0.5 text-accent-foreground transition-colors duration-ds-fast ease-ds-standard data-[state=open]:bg-primary dark:data-[state=open]:bg-secondary data-[state=open]:text-primary-foreground data-[loading=true]:animate-pulse data-[loading=true]:cursor-wait data-[loading=true]:pointer-events-none"
    :style="{ marginLeft: `${level * DEEP_MARGIN}px` }"
    data-revealer="true"
    :data-revealer-kind="kind"
    :data-state="opened ? 'open' : undefined"
    :data-revealer-path="path"
    @click="$emit('click', $event)"
    @mousedown.stop
  >
    <Minus class="hidden size-3 group-data-[state=open]:block" />
    <Plus class="size-3 group-data-[state=open]:hidden" />
  </div>
</template>

<script setup lang="ts">
import { Minus, Plus } from '@lucide/vue'

import { DEEP_MARGIN } from '@/components/DS/patterns/Pivot/utils/const'

type Props = {
  /** Nesting depth, for Modern's left-margin indent. 0 for Classic. */
  level?: number
  opened?: boolean
  path?: string
  /**
   * Row revealers (the default) are swept by `usePivotData`'s `collapseAll`/`revealAllLoaded` —
   * a global row expand/collapse-all DOM sweep that queries every `[data-revealer]` under the
   * grid. Column-header revealers must opt out of that sweep (`kind="column"`), or "Expand/
   * Collapse all rows" flips their +/- icon via raw `data-state` without touching
   * `collapsedColGroups`, leaving the icon out of sync with the actual column state.
   */
  kind?: 'row' | 'column'
}

type Emits = {
  click: [event: MouseEvent]
}

const { level = 0, kind = 'row' } = defineProps<Props>()
defineEmits<Emits>()
</script>
